const fbEventNames = {
    CONTENT_VIEW: "fb_mobile_content_view",
    ADD_TO_WISHLIST: "fb_mobile_add_to_wishlist",
    PURCHASE: "fb_mobile_purchase",
    INIT_CHECKOUT: "fb_mobile_initiated_checkout",
    COMPLETE_REGISTRATION: "fb_mobile_complete_registration",
    ADD_TO_CART: "fb_mobile_add_to_cart",
};

export const eventNames = {
    ADD_TO_CART: "add_to_cart",
    SAVE_PRODUCT: "save_product",
    SAVE_OUTFIT: "like_outfit",
    CREATE_ACCOUNT: "create_account",
    CHECKOUT_INIT: "checkout_init",
    PURCHASE: "purchase",
    VIEW_PRODUCT: "view_product",
    VIEW_OUTFIT: "view_outfit",
};

const fbEventNameParser = {
    [eventNames.ADD_TO_CART]: fbEventNames.ADD_TO_CART,
    [eventNames.SAVE_PRODUCT]: fbEventNames.ADD_TO_WISHLIST,
    [eventNames.SAVE_OUTFIT]: fbEventNames.ADD_TO_WISHLIST,
    [eventNames.CREATE_ACCOUNT]: fbEventNames.COMPLETE_REGISTRATION,
    [eventNames.CHECKOUT_INIT]: fbEventNames.INIT_CHECKOUT,
    [eventNames.PURCHASE]: fbEventNames.PURCHASE,
    [eventNames.VIEW_PRODUCT]: fbEventNames.CONTENT_VIEW,
    [eventNames.VIEW_OUTFIT]: fbEventNames.CONTENT_VIEW,
};

export const trackEvent = (eventName, props) => {
    trackEventByFirebase(eventName, props);
    trackEventByFacebook(eventName, props);
};

export const trackEventByFirebase = (eventName, props) => {
    if (typeof window.FirebasePlugin !== "undefined") {
        window.FirebasePlugin.logEvent(eventName, {
            ...props,
            firebase_screen: window.currentFirebaseScreenName,
        });
    }
};

export const trackEventByFacebook = (eventName, props) => {
    const valueToSum = new Number(props.price || props.value || 0);
    const fbProps = {
        fb_content_id: props.content_id || props.transaction_id,
        fb_content_type: props.content_type,
        fb_num_items: props.num_items || (props.items && props.items.length),
        fb_currency: typeof valueToSum !== 'undefined' ? (props.currency || "USD") : null,
        fb_content: props.items && JSON.stringify(props.items.map(item => ({
            id: item.item_id,
            quantity: item.quantity
        }))),
    };

    if(props.items && props.items.length > 0) {
        fbProps.fb_content_id = JSON.stringify(props.items.map(item => item.item_id));
        fbProps.fb_content_type = 'product_group';
    }

    const fbEventName = fbEventNameParser[eventName] || eventName;

    switch (fbEventName) {
        case fbEventNames.CONTENT_VIEW:
        case fbEventNames.ADD_TO_WISHLIST:
            fbProps.fb_content_type = eventName.includes("outfit")
                ? "outfit"
                : "product";
            break;
        case fbEventNames.PURCHASE:
        case fbEventNames.INIT_CHECKOUT:
            fbProps.fb_content_type = "product_group";
    }

    if (typeof window.facebookConnectPlugin !== "undefined") {
        window.facebookConnectPlugin.logEvent(fbEventName, fbProps, valueToSum);
    }
};
